// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

// Access is handled at the root route

export const Route = createFileRoute('/$accountId/_admin/service-manager')({
  component: Outlet,
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'service-manager:title' },
});
